import { Component, OnInit, Input, ElementRef, ViewChild, Renderer2 } from '@angular/core';
import { DashboardService } from '../../dashboard.service';
import * as echarts from 'echarts';
import EChartOption = echarts.EChartOption;



// EXEMPLE FORMAT VOIR DOC: https://ecomfe.github.io/echarts-examples/public/index.html#chart-type-pie

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'q-dashboard-item-graphique',
  templateUrl: './dashboard-item-graphique.component.html',
  styleUrls: ['./dashboard-item-graphique.component.css']
})
export class DashboardItemGraphiqueComponent implements OnInit {

  myChart: any;
  @Input() id: string;
  @Input() idCpt: string;
  @Input() title: string;
  @Input() set size(value: {height: number, width: number}) {
    this.render.setStyle(this.graphtest.nativeElement, 'height', `${value.height}px`);
    this.render.setStyle(this.graphtest.nativeElement.children[0], 'height', `${value.height}px`);
    this.render.setStyle(this.graphtest.nativeElement.children[0].children[0], 'height', `${value.height}px`);
    this.render.setStyle(this.graphtest.nativeElement, 'width', `${value.width}px`);
    this.render.setStyle(this.graphtest.nativeElement.children[0], 'width', `${value.width}px`);
    this.render.setStyle(this.graphtest.nativeElement.children[0].children[0], 'width', `${value.width}px`);
  }
  @ViewChild('graphtest', { static: false }) graphtest: ElementRef;

  constructor(
    private dashboardservice: DashboardService,
    private render: Renderer2

  ) {}

  ngOnInit(): void {
    this.dashboardservice.getGraphique(this.idCpt).subscribe(
      (res: any) => {
        setTimeout(() => {
          this.myChart = echarts.init(this.graphtest.nativeElement);

          this.myChart.setOption({
            title : res.title,
            xAxis: res.axisX,
            yAxis: res.axisY,
            series: res.series
          });
        }, 1);
      }
    );
  }
}
